const $ = jQuery.noConflict();

class SetIntroHeight {
    constructor(IntroWrap, sideWrapper) {
        this.IntroWrap = IntroWrap;
        this.sideWrapper  = sideWrapper;
    }
    init() {
        const sideWrapHeight = $(this.sideWrapper).outerHeight();
        $(this.IntroWrap).css('min-height', sideWrapHeight);
    }
}

const setSJIntroHeight = new SetIntroHeight('.sj-post-intro__wrap', '.side-wrapper');
const setRegionIntroHeight = new SetIntroHeight('.regions-destinations-intro .intro-column', '.intro-image-wrapper img');

export default setSJIntroHeight;
export { setRegionIntroHeight }

